




















































































































import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { ICruise, IFullRoute } from "@/@types/cruiseOffers/cruiseList";
import { getDate } from "@/services/dateTime/getFullDate";
import { IRouteCity as ICity } from "@/@types/routeInfo/route-info";
import Booking from "./booking.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, Booking } })
export default class CruiseListCard extends Vue {
  @Prop({ type: Array, default: [] }) cruises!: Array<ICruise>;
  @Prop({ type: Array, default: [] }) citys!: Array<ICity>;
  @Inject() readonly cruiseFolder!: string;

  cruise_id = "";

  get cruise(): ICruise | undefined {
    return this.cruises.find((cruise) => cruise._id == this.cruise_id);
  }

  openCruise(id: string): void {
    this.cruise_id = id;
    this.$nextTick(() => this.$bvModal.show("cruise"));
  }

  getDate(date: string | Date): string {
    return getDate(date);
  }

  getCityName(rcity: IFullRoute): string {
    let city = this.citys.find((c) => c._id == rcity._id);
    if (!city) city = this.citys.find((c) => c.code == rcity.code);
    return city ? this.$getLocale(city.name) : "-";
  }
}
